// extracted by mini-css-extract-plugin
export default {"container":"Home_container__I9Dyu","sections":"Home_sections__E1byU","section":"Home_section__mPxp9"};